<template>
  <b-row>
    <b-col md="3">
      <b-form-group class="mb-0">
        <b-form-select
          id="order"
          :class="sortDropdownClass"
          size="sm"
          v-model="selectedSortMethod"
          :options="sortMethods"
          @change="$emit('sort', selectedSortMethod)"
          ></b-form-select>
      </b-form-group>
    </b-col>
    <b-col md="2">
      <b-form-checkbox
        v-model="confirmedOnlyCopy"
        id="only-available"
        name="only-available"
        @change="$emit('confirmedOnlyChange', $event)"
      >
        <translate>confirmed</translate>
      </b-form-checkbox>
    </b-col>
    <b-col md="2">
      <b-form-checkbox
        v-model="freeChildOnlyCopy"
        id="free_child"
        name="free_child"
        @change="$emit('freeChildOnlyChange', $event)"
      >
        <translate>free child</translate>
      </b-form-checkbox>
    </b-col>
    <b-col md="5">
      <b-button size="sm" class="float-right" variant="primary" @click="resetFilters()"><translate>Reset filter</translate></b-button>
    </b-col>
    <b-col sm="12"><hr class="my1"></b-col>
    <b-col md="1">
      <b-dropdown :text="$gettext('pret')" class="btn btn-block p-0 btn-filters btn-sm" variant="outline-secondary" size="sm">
        <b-form-checkbox-group
          v-model="selectedPriceFiltersCopy"
          :options="priceFilters"
          @change="$emit('priceFiltersChange', selectedPriceFiltersCopy)"
          stacked
          >
        </b-form-checkbox-group>
      </b-dropdown>
    </b-col>
    <b-col>
      <b-dropdown :text="$gettext('Accomodation type')" class="btn btn-block p-0 btn-filters btn-sm" variant="outline-secondary" size="sm">
        <!-- hotel types -->
        <b-form-checkbox-group
          v-model="selectedHotelTypesCopy"
          :options="hotelTypes"
          text-field="label"
          value-field="id"
          @change="$emit('hotelTypesChange', selectedHotelTypesCopy)"
          stacked
          >
        </b-form-checkbox-group>
      </b-dropdown>
    </b-col>
    <b-col>
      <b-dropdown :text="$gettext('Accomodation')" class="btn btn-block p-0 btn-filters btn-sm" variant="outline-secondary" size="sm">
        <!-- hotel amenities -->
        <b-form-checkbox-group
          v-model="selectedHotelAmenitiesCopy"
          :options="hotelAmenities"
          text-field="label"
          value-field="id"
          @change="$emit('hotelAmenitiesChange', selectedHotelAmenitiesCopy)"
          stacked
          >
        </b-form-checkbox-group>
      </b-dropdown>
    </b-col>
    <b-col>
      <b-dropdown :text="$gettext('Rooms')" class="btn btn-block p-0 btn-filters btn-sm" variant="outline-secondary" size="sm">
        <!-- room amenities -->
        <b-form-checkbox-group
          v-model="selectedRoomAmenitiesCopy"
          :options="roomAmenities"
          text-field="label"
          value-field="id"
          @change="$emit('roomAmenitiesChange', selectedRoomAmenitiesCopy)"
          stacked
          >
        </b-form-checkbox-group>
      </b-dropdown>
    </b-col>
    <b-col>
      <b-dropdown :text="$gettext('Hotel Theme')" class="btn btn-block p-0 btn-filters btn-sm" variant="outline-secondary" size="sm">
        <!-- hotel themes -->
        <b-form-checkbox-group
          v-model="selectedHotelThemesCopy"
          :options="hotelThemes"
          text-field="label"
          value-field="id"
          @change="$emit('hotelThemesChange', selectedHotelThemesCopy)"
          stacked
          >
        </b-form-checkbox-group>
      </b-dropdown>
    </b-col>
  </b-row>
</template>

<script>
import formMixin from '@/app/private/shared/mixins/search_forms'

export default {
  name: 'SortFields',
  props: {
    hotelTypes: {
      type: Array,
      required: true
    },
    selectedHotelTypes: {
      type: Array,
      required: true
    },
    hotelThemes: {
      type: Array,
      required: true
    },
    selectedHotelThemes: {
      type: Array,
      required: true
    },
    hotelAmenities: {
      type: Array,
      required: true
    },
    selectedHotelAmenities: {
      type: Array,
      required: true
    },
    roomAmenities: {
      type: Array,
      required: true
    },
    selectedRoomAmenities: {
      type: Array,
      required: true
    },
    priceFilters: {
      type: Array,
      required: true
    },
    selectedPriceFilters: {
      type: Array,
      required: true
    },
    confirmedOnly: {
      type: Boolean,
      required: true
    },
    freeChildOnly: {
      type: Boolean,
      required: true
    }
  },
  mixins: [formMixin],
  data () {
    return {
      selectedPriceFiltersCopy: [...this.selectedPriceFilters],
      selectedHotelTypesCopy: [...this.selectedHotelTypes],
      selectedHotelThemesCopy: [...this.selectedHotelThemes],
      selectedHotelAmenitiesCopy: [...this.selectedHotelAmenities],
      selectedRoomAmenitiesCopy: [...this.selectedRoomAmenities],
      confirmedOnlyCopy: this.confirmedOnly,
      freeChildOnlyCopy: this.freeChildOnly
    }
  },
  methods: {
    resetFilters () {
      this.$emit('filtersReset')
      this.selectedPriceFiltersCopy = []
      this.selectedHotelTypesCopy = []
      this.selectedHotelThemesCopy = []
      this.selectedHotelAmenitiesCopy = []
      this.confirmedOnlyCopy = false
      this.freeChildOnlyCopy = false
    }
  }
}

</script>

<style lang="scss">
  .btn-filters {
    .dropdown-menu.show {
      padding:.5rem;
      width: 100%;
    }
  }
</style>
